import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
const API_URL = process.env.REACT_APP_API_URL;
const GlobalNotification = () => {
  const [alerts, setAlerts] = useState([]);
  const location = useLocation();
  const role = localStorage.getItem("role");
  const userId = localStorage.getItem("loginId");

  // We'll reuse your device-fetching logic
  const [macAddresses, setMacAddresses] = useState([]);

  // ✅ Fetch MAC addresses for this user
  const getMacAddresses = async () => {
    try {
      const response = await fetch(
        `${API_URL}/index.php?getmac=true`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      const devices = await response.json();

      let relevantDevices = devices;
      if (role === "User" && userId) {
        relevantDevices = devices.filter((d) => d.userid === userId);
      }

      // Store MAC addresses only
      setMacAddresses(relevantDevices.map((d) => d.mac_address));
    } catch (error) {
      console.error("Error fetching MAC addresses:", error);
    }
  };
  useEffect(() => {
    // Clear alerts if role is not User
    if (role !== "User") {
      setAlerts([]);
    }
  }, [role]);
  // ✅ Fetch unread notifications for all user's devices
  const fetchNotifications = async () => {
    try {
      if (macAddresses.length === 0) return;

      const unreadNotifications = [];

      for (const mac of macAddresses) {
        const res = await fetch(
          `${API_URL}/get_notification.php?mac=${mac}`,
          { method: "POST" }
        );
        const notifications = (await res.json()) || [];
       // console.log(notifications);
        const unread = notifications.filter((n) => n.status === "unread");
        unreadNotifications.push(...unread);
      }

      if (unreadNotifications.length > 0) {
        setAlerts(unreadNotifications);
        unreadNotifications.forEach((n) => updateStatus(n.id));
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  // ✅ Mark a notification as read after showing it
  const updateStatus = async (id) => {
    try {
      await fetch(`${API_URL}/update_notification.php`, {
        method: "POST",
        body: JSON.stringify({
          id: id,
          status: "read",
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
     // console.log(`Marked notification ${id} as read`);
    } catch (error) {
      console.error("Error updating notification:", error);
    }
  };

  // ✅ Handle fetching MACs and notifications periodically
  useEffect(() => {
    if (role !== "User" || location.pathname === "/") return; // Skip login and admins

    getMacAddresses();
    // eslint-disable-next-line
  }, [role, location.pathname]);

  useEffect(() => {
    if (macAddresses.length === 0) return;

    fetchNotifications(); // Initial fetch
    const interval = setInterval(fetchNotifications, 15000); // every 30s

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [macAddresses]);

  if (alerts.length === 0) return null;
  const handleClose = (id) => {
    setAlerts((prev) => prev.filter((a) => a.id !== id));
    updateStatus(id); // mark as read on close
  };
  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: 9999,
      }}
    >
      {alerts.map((a) => (
        <div
          key={a.id}
          style={{
            backgroundColor: "#ff4444",
            color: "white",
            padding: "15px 20px 10px 20px",
            marginBottom: "10px",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
            minWidth: "250px",
            position: "relative",
          }}
        >
          {/* Close icon */}
          <button
            onClick={() => handleClose(a.id)}
            style={{
              position: "absolute",
              top: "5px",
              right: "10px",
              background: "transparent",
              border: "none",
              color: "white",
              fontSize: "18px",
              cursor: "pointer",
            }}
          >
            ×
          </button>

          <strong style={{ fontSize: "12px" }}>⚠️ Alert:{a.mac}</strong>
          <br />
          {a.message}
          <br />
          <small>{new Date(a.timestamp).toLocaleString()}</small>
        </div>
      ))}
    </div>
  );
};

export default GlobalNotification;
